<template>
	<v-container class="none-fluid link">
		<div class="mx-auto">
			<br />
			<p v-html="$sanitize(intro.content)"></p>
			<br />
            <v-expansion-panels multiple>
				<v-expansion-panel v-for="skill in skills" :key="skill.subtitle">
					<v-expansion-panel-header class="expansion-header">{{ skill.subtitle }}</v-expansion-panel-header>
					<v-expansion-panel-content class="expansion-content">
						<div class="expansion-subsection" v-html="$sanitize(skill.content)"></div>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
			
		</div>
	</v-container>
</template>

<script>
import {
	getIntroduction,
	getSkills,
} from "../../service/common_skills";

export default {
	data() {
		return {
			intro: {},
			skills: [],
		};
	},
	mounted() {
		// get introduction
		getIntroduction()
			.then(intro => {
				this.intro = intro;
			})
			.catch(err => {
				console.error(err.message);
			});
		// get researchers
		getSkills()
			.then(result => {
				const { skills } = result;
				this.skills = skills;
			})
			.catch(err => {
				console.error(err.message);
			});
	}
};
</script>

<style lang="scss">
		ul {
			margin-left: 20px;
			margin-top: 1em;
        }
</style>